/**
 * @file Comportement d'arme 'pierce' : Perforant : balle rapide qui traverse jusqu'a params.pierceMaxHits cibles (PenetratingBulletLifetime = portee).
 */
import type { SimContext } from '../../Context';
import { applyDamage, rollCrit } from '../../combat/damage';
import type { With } from '../../ecs/World';
import { DEG } from '../../math/geometry';
import { spawnProjectile } from '../projectiles';
import type { HitOutcome, ShotContext, WeaponBehaviorModule } from '../WeaponBehavior';
import { announceShot } from './common';

/**
 * fire : comme single mais cone fixe (params.spreadMinDeg) et perforation params.pierceMaxHits.
 * onHit : une seule fois par cible ; degats x pierceFalloff^(cibles deja traversees) ; consomme quand la perforation est epuisee.
 */
export const pierceBehavior: WeaponBehaviorModule = {
  id: 'pierce',
  fire(ctx: SimContext, shot: ShotContext): void {
    const { weapon: w, cat } = shot;
    const p = w.params;
    const angle = shot.aimAngle + ctx.rng.combat.range(-1, 1) * (p.spreadMinDeg / 2) * DEG;
    const roll = rollCrit(ctx, w, w.damage);
    const proj = spawnProjectile(ctx, {
      kind: 'bullet',
      behavior: 'pierce',
      ownerId: cat.id,
      weaponDefId: w.def.id,
      slot: w.slot,
      x: shot.originX,
      y: shot.originY,
      angle,
      speed: p.projectileSpeed,
      radius: p.projectileRadius,
      range: w.range,
      damage: roll.damage,
      crit: roll.crit,
      pierce: p.pierceMaxHits,
    });
    announceShot(ctx, shot, 'pierce', [proj.id]);
  },
  onHit(ctx: SimContext, proj: With<'projectile'>, target: With<'target' | 'health'>): HitOutcome {
    const pr = proj.projectile;
    if (pr.hitIds.includes(target.id)) return { consumed: false };
    const falloff = Math.pow(ctx.config.behaviors.pierce.pierceFalloff, pr.hitIds.length);
    pr.hitIds.push(target.id);
    applyDamage(ctx, target, falloff === 1 ? pr.damage : pr.damage.times(falloff), pr.crit, 'pierce', proj.transform.x, proj.transform.y);
    pr.pierceLeft--;
    return { consumed: pr.pierceLeft < 0 };
  },
};
